export const PopupAnimationMs = 400;
export const ScannerAnimationMs = 150;